"use client";

import { AlertCircle, CheckCircle2 } from "lucide-react";
import { Input } from "@/components/atoms/Input";

interface PhoneInputFieldProps {
    id: string;
    value: string;
    onChange: (value: string) => void;
    onBlur?: () => void;
    placeholder?: string;
    disabled?: boolean;
    touched?: boolean;
    isValid?: boolean;
    hasError: boolean;
    className?: string;
}

export function PhoneInputField({
    id,
    value,
    onChange,
    onBlur,
    placeholder = "(555) 000-0000",
    disabled = false,
    touched = false,
    isValid = false,
    hasError,
    className = "",
}: PhoneInputFieldProps) {
    return (
        <div className={`relative ${className}`}>
            <Input
                id={id}
                type="tel"
                value={value}
                onChange={(event) => onChange(event.target.value)}
                onBlur={onBlur}
                placeholder={placeholder}
                disabled={disabled}
                inputClassName={`px-4 py-2.5 rounded-md border-2 shadow-none text-sm font-medium outline-none ${
                    hasError
                        ? "border-[#d0464b] bg-[#d0464b]/5"
                        : isValid && touched
                          ? "border-[#098487] bg-[#098487]/5"
                          : "border-[#c9d1d4] bg-white"
                } ${disabled ? "opacity-60 cursor-not-allowed" : ""}`}
            />

            {touched && (
                <div className="absolute right-3 top-1/2 -translate-y-1/2">
                    {hasError ? (
                        <AlertCircle className="w-5 h-5 text-[#d0464b]" strokeWidth={2} />
                    ) : isValid ? (
                        <CheckCircle2 className="w-5 h-5 text-[#098487]" strokeWidth={2} />
                    ) : null}
                </div>
            )}
        </div>
    );
}
